import driverProfileReducer from "./driverProfileReducer";
import commonReducer from "./commonReducer";
import { combineReducers } from "redux";

//Combine all the sub reducers
const rootReducer = combineReducers({
  driverProfile: driverProfileReducer,
  common: commonReducer,
});

export default rootReducer;
